import { useEffect, useState } from "react";
import { UtilsService } from "../../services/utils";

function MonthTable({ list }: any) {

  const [groupByList, setGroupByList] = useState<any>([]);

  useEffect(() => {
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ]
    
    const groupedData = list.reduce((acc: any, item: any) => {
      
      const date = new Date(item.date);
      const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`;
      const key = `${monthYear}-${item.customer.name}-${item.type}`;
    
      if (!acc[key]) {
        acc[key] = {
          monthYear,
          customerName: item.customer.name,
          type: item.type,
          totalAmount: 0
        };
      }
    
      acc[key].totalAmount += item.amount;
      return acc;
    }, {});
    
    const report = Object.values(groupedData);
    
    report.sort((a: any, b: any) => {
      const [monthA, yearA] = a.monthYear.split(' ');
      const [monthB, yearB] = b.monthYear.split(' ');

      const dateA = new Date(`${yearA}-${months.indexOf(monthA) + 1}-01`);
      const dateB = new Date(`${yearB}-${months.indexOf(monthB) + 1}-01`);

      return dateA.getTime() - dateB.getTime();
    });

    setGroupByList(report);
  }, [list])
  
  return (
    <table
      className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
      id="expenses-table-month"
    >
      <thead>
        <tr
          className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
          role="row"
        >
          <th
            aria-label="Role: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Mes
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Role: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Cliente
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Last login: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Tipo
            </span>
            <span className="dt-column-order" />
          </th>
          <th
            aria-label="Last login: Activate to sort"
            className="min-w-125px "
            colSpan={1}
            rowSpan={1}
            tabIndex={0}
          >
            <span className="" >
              Monto
            </span>
            <span className="dt-column-order" />
          </th>
        </tr>
      </thead>
      <tbody className="text-gray-600 fw-semibold">
        {groupByList.map((row: any, index: number) => (
          <tr key={index}>
            <td>{row.monthYear}</td>
            <td>
              <p className="text-gray-800 m-0">{row.customerName}</p>
            </td>
            <td className="text-capitalize">{row.type}</td>
            <td>$ {UtilsService.numberFormat(row.totalAmount)}</td>
          </tr>
        ))}
      </tbody>
      <tfoot />
    </table>
  );
}

export default MonthTable;
